import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, output, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { GenericMenuItem } from '../generic-menu/generic-menu-item.model';
import { __ } from '@app/shared/functions/object.functions';

@Component({
    selector: 'hypecast-generic-actions',
    imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule],
    templateUrl: './generic-actions.component.html',
    styleUrl: './generic-actions.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericActionsComponent implements OnInit {

  actions: GenericMenuItem[] = [];

  readonly item = input<any>(undefined);

  readonly items = input<GenericMenuItem[]>([]);

  // tslint:disable-next-line:no-output-on-prefix
  readonly onItemClicked = output<GenericMenuItem>();

  constructor(
    private router: Router
  ) {}

  ngOnInit() {
    this.actions = this.items();
  }

  /**
   * The callback when a menu item was clicked. Executes up to three handling actions:
   * 1. Emits the clicked menu item
   * 2. Navigates to a provided route
   * 3. Opens a dialog using the provided open dialog method
   *
   * @memberof GenericActionsComponent
   */
  itemClick(menuItem: GenericMenuItem): void {
    if (!__.IsNullOrUndefined(menuItem.actionType)) {
      this.onItemClicked.emit(menuItem);
    }
    if (!__.IsNullOrUndefined(menuItem.routerLink)) {
      this.router.navigate([menuItem.routerLink]);
    }
    if (!__.IsNullOrUndefined(menuItem.execute)) {
      menuItem.execute.call(
        __.IsNullOrUndefined(menuItem.context) ? this : menuItem.context,
        this.item(),
      );
    }
  }

  checkDisabled(menuItem: GenericMenuItem) {
    if (typeof (menuItem.disabled) === typeof (true)) {
      return menuItem.disabled;
    }
    if (this.isFunction(menuItem.disabled)) {
      return menuItem.disabled.call(__.IsNullOrUndefined(menuItem.context) ? this : menuItem.context, this.item());
    }
    return true;
  }

  checkIsLoading(menuItem: GenericMenuItem) {
    if (typeof (menuItem.isLoading) === typeof (true)) {
      return menuItem.isLoading;
    }
    if (this.isFunction(menuItem.isLoading)) {
      return menuItem.isLoading.call(__.IsNullOrUndefined(menuItem.context) ? this : menuItem.context, this.item());
    }
    return false;
  }

  checkIsVisible(menuItem: GenericMenuItem) {
    if (typeof (menuItem.visible) === typeof (true)) {
      return menuItem.visible;
    }
    if (this.isFunction(menuItem.visible)) {
      return menuItem.visible.call(__.IsNullOrUndefined(menuItem.context) ? this : menuItem.context, this.item());
    }
    return false;
  }

  private isFunction(functionToCheck: any) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
  }
}
